import request from '@/utils/request'

// 测试时使用登录接口
export function getloginDemoApi(account) {
    return request({
        url: `/auth/pwd/login/demo/${account}/user/7Z8t9x0y1u2i3o4p5a6s7d8f9g0h1j2k3l4m=`,
        method: 'post',
    })
}
/**
 * 获取token
 */
export function getTokenCodeApi() {
    return request({
        url: '/auth/cust/login/user/token',
        method: 'get',
    })
}

/**
 * 获取token
 */
export function getWeixinTokenCodeApi() {
    return request({
        url: '/auth/wechat/login/user/token',
        method: 'get',
    })
}


/**
 * 获取用户信息
 */
export function getUserInfoApi(authCode) {
    return request({
        url: `/auth/cust/login/user/${authCode}`,
        method: 'get',
    })
}

/**
 * 获取用户信息
 */
export function getWeixinUserInfoApi(authCode) {
    return request({
        url: `/auth/wechat/login/user/${authCode}`,
        method: 'get',
    })
}

// 统计活跃度
export function getHydApi() {
  return request({
    url: `/auth/admin/login/hyd/ykbh5`,
    method: 'get',
  })
}

// 统计活跃度
export function getHydWechatApi() {
  return request({
    url: `/auth/admin/login/hyd/ykbwechat`,
    method: 'get',
  })
}
